import React from 'react';
import { Box, Container, Theme, Typography } from '@material-ui/core';
import { createStyles, makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      background: '#ffffff 0% 0% no-repeat padding-box',
      maxWidth: '523px',
    },
    title: {
      fontSize: '32px',
      fontWeight: 'bold',
      textAlign: 'center',
      marginBottom: theme.spacing(2),
      [theme.breakpoints.down(768)]: {
        fontSize: '24px',
      },
      '& span': {
        display: 'block',
      },
    },
    subtitle: {
      fontSize: '14px',
      textAlign: 'center',
      marginBottom: theme.spacing(5),
    },
    img: {
      height: '100%',
      background: 'transparent',
      marginBottom: theme.spacing(5),
      '& img': {
        width: '100%',
      },
    },
    imgDiv: {
      position: 'relative',
      width: '100%',
      background: '#f2f3fB 0% 0% no-repeat padding-box',
      marginBottom: theme.spacing(5),
      '&:before': {
        content: '""',
        display: 'block',
        paddingTop: '55.5%',
      },
    },
    article: {
      wordWrap: 'break-word',
      ' & > *': {
        marginBottom: theme.spacing(5),
        '&:last-child': {
          marginBottom: 0,
        },
      },
      '& .MuiTypography-body1': {
        fontSize: '14px',
        paddingTop: 0,
        paddingBottom: 0,
      },
      '& .MuiTypography-body2': {
        fontSize: '14px',
      },
      '& ul.MuiList-root': { listStyle: 'disc' },
      '& .MuiList-root': {
        '& ::marker': { lineHeight: '21px' },
        '& .MuiListItem-root': {
          display: 'list-item',
          padding: theme.spacing(0, 0, 0, 2),
          marginTop: theme.spacing(1),
          '&:first-child': { marginTop: 0 },
          '& .MuiListItemText-root': { margin: 0 },
        },
      },
      '& .MuiList-padding': { padding: theme.spacing(0, 0, 0, 4) },
    },
  }),
);

export interface DocumentIntroductionProps {
  title?: React.ReactNode;
  subtitle?: React.ReactNode;
  imgSrc?: string;
  imgAlt?: string;
  children?: React.ReactNode;
  className?: string;
}

export const DocumentIntroduction: React.FC<DocumentIntroductionProps> = ({
  title,
  subtitle,
  imgSrc,
  imgAlt,
  children,
  className = '',
}) => {
  const classes = useStyles();

  return (
    <Container disableGutters className={`${classes.root} ${className}`}>
      <Typography component="h1" className={classes.title}>
        {title}
      </Typography>
      <Typography
        variant="subtitle1"
        component="p"
        className={classes.subtitle}
      >
        {subtitle}
      </Typography>
      {imgSrc ? (
        <Box className={classes.img}>
          <img src={imgSrc} alt={imgAlt} />
        </Box>
      ) : (
        <Box className={classes.imgDiv}></Box>
      )}
      <Box component="article" className={classes.article}>
        {children}
      </Box>
    </Container>
  );
};
